<template>
  <div v-if="internalForm">
    <div
      v-for="(page, index) in internalForm"
      :key="index"
      class="page"
    >
      <v-row
        v-show="currentPage == index"
      >
        <v-col cols="12">
          <form>
            <FormElement
              v-if="isVisible(el)"
              v-for="(el, fIdx) in page"
              :id="`el-${el.id}`"
              :key="el.id"
              v-model="internalValue[el.id]"
              :type="el.type"
              :field-id="el.id"
              :form-type="type"
              :form-doc="docId"
              :form-data="internalValue"
              :tabindex="fIdx + 1"
              v-bind="el"
            />
          </form>
        </v-col>
      </v-row>
    </div>
    <v-footer app>
      <v-row>
        <v-col v-if="currentPage > 0">
          <v-btn
            color="primary"
            large
            block
            @click="prevPage"
          >
            {{ $t('misc.previous') }}
          </v-btn>
        </v-col>
        <v-col v-if="currentPage >= internalForm.length - 1">
          <v-btn
            color="primary"
            large
            block
            :disabled="!formValid"
            @click="saveForm"
          >
            {{ $t(validate ? 'misc.send' : 'misc.save') }}
          </v-btn>
        </v-col>
        <v-col v-if="currentPage < internalForm.length - 1">
          <v-btn
            color="primary"
            large
            block
            @click="nextPage"
          >
            {{ $t('misc.next') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import FormElement from './FormElement';
import { checkConditions, checkFormValid } from '@/lib/validation';

export default {
  name: 'FormComponent',
  components: {
    FormElement
  },
  props: {
    value: { type: [Object, Array], default: () => {} },
    form: { type: Array, default: () => [] },
    type: { type: String, required: true },
    docId: { type: String, required: true },
    validate: { type: Boolean, default: false },
  },
  data: () => ({
    currentPage: 0
  }),
  computed: {
    internalValue: {
      get () {
        return (this.value instanceof Array) ? {} : this.value;
      },
      set (v) {
        this.$emit('input', v);
      }
    },
    internalForm () {
      return this.splitForm(this.form);
    },
    formValid () {
      if (this.validate) {
        return checkFormValid(this.form, this.internalValue);
      }

      return true;
    }
  },
  watch: {
    form: {
      immediate: true,
      handler (form) {
        if (!form) return;

        for (const el of form) {
          if (this.internalValue[el.id] === undefined && ['page_break', 'text', 'image_display'].indexOf(el.type) === -1) {
            this.$set(this.internalValue, el.id, null);
          }
        }
        // TODO: Check if this can be deleted
        this.internalValue = this.internalValue;
      }
    }
  },
  methods: {
    prevPage () {
      this.currentPage--;
    },
    nextPage () {
      this.currentPage++;
    },
    saveForm () {
      this.$emit('submit', this.value);
    },
    isVisible(el) {
      if (el instanceof Array) {
        el = { visibility: el };
      } else if (!el.visibility) {
        return true;
      }

      let link = 'and';
      if (el.vLink) {
        link = el.vLink;
      }

      return checkConditions(el.visibility, link, this.internalValue);
    },
    splitForm (form) {
      const pages = [];
      let tmpPage = [];

      for (const el of form) {
        if (el.type === 'page_break' && this.isVisible(el)) {
          pages.push(tmpPage);
          tmpPage = [];
        } else {
          tmpPage.push(el);
        }
      }

      if (tmpPage.length > 0 || pages.length === 0) {
        pages.push(tmpPage);
      }

      return pages;
    }
  }
};
</script>

<style lang="scss" scoped>
.form-element {
  margin-bottom: 14px;
}
</style>
